import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { animated, useTrail } from "react-spring";
import { AccountSearchContext } from "../../../../Context/AccountSearchContext/AccountSearchContext";
import "./AdminAccountsListItem.css";

export const AdminAccountsListItem = ({
  id,
  title,
  status,
  type = "ACCOUNT",
  accounts = 0,
  usersCount = 0,
  listActions = [],
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [hasMouseOver, setHasMouseOver] = useState(false);

  return (
    <div
      className="AdminAccountsListItem"
      onMouseEnter={() => setHasMouseOver(true)}
      onMouseLeave={() => setHasMouseOver(false)}
      onTouchStart={() => setHasMouseOver(true)}
    >
      <div className="AdminAccountsListItem__name">{title}</div>
      <div className="AdminAccountsListItem__status">
        <div
          className="AdminAccountsListItem__status--indicator"
          style={{
            backgroundColor: status === "Active" ? "#56B267" : "#D69D23",
          }}
        ></div>
        <div className="AdminAccountsListItem__status--text">{t(status)}</div>
      </div>
      {type === "DISTRIBUTOR" && (
        <div className="AdminAccountsListItem__information">{accounts}</div>
      )}
      {type === "ACCOUNT" && (
        <div className="AdminAccountsListItem__information">{usersCount}</div>
      )}

      <div className="AdminAccountsListItem__actions">
        <AdminAccountListItemActions
          location={location}
          id={id}
          mouseOver={hasMouseOver}
          listActions={listActions}
          name={title}
        />
      </div>
    </div>
  );
};

export const AdminAccountListItemActions = ({
  location,
  id,
  mouseOver,
  listActions,
  name = "",
}) => {
  const { t } = useTranslation();
  const { setSearchTerm } = useContext(AccountSearchContext);
  const trail = useTrail(listActions.length, {
    config: { duration: 150 },
    opacity: mouseOver ? 1 : 0,
    from: { opacity: 0 },
  });

  const getLinkPath = (input) => {
    switch (input.action) {
      case "edit":
        return `${location.pathname}/${id}/edit`;

      case "add-user":
        return `${location.pathname}/${id}/invite-user`;

      case "add-account":
        return `/admin/accounts/${id}/new`;

      case "manage-account":
        return "/admin/accounts";

      case "edit-user":
        return `${location.pathname}/${id}/manage`;

      default:
        return `${location.pathname}/`;
    }
  };

  return (
    <div className="AdminAccountListItemActions">
      {mouseOver &&
        trail.map((props, index) => (
          <animated.div
            className="AdminAccountListItemActions__action"
            key={index}
          >
            <Link
              to={getLinkPath(listActions[index])}
              onClick={() => {
                if (listActions[index].action === "manage-account") {
                  setSearchTerm("dist:" + name);
                }
              }}
            >
              <div className="AdminAccountListItemActions__action-button">
                {t(listActions[index].label)}
              </div>
            </Link>
          </animated.div>
        ))}
    </div>
  );
};
